/**
 * 统一处理错误码
 */
'use strict';
const ERROR = 'error';

const CONFIG = {
  over_withdrawal_amount: {
    type: ERROR,
    en: " The single minimum withdrawal amount is 5,000 BP, and the maximum withdrawal amount is 10,000,000 BP.",
    zn: "单次最小提现数量为 5,000 BP，最大提现数量为 10,000,000 BP。"
  },
  RELOAD_THE_PAGE: {
    type: ERROR,
    zn: '刷新一下',
    en: 'reload the page'
  },
  amount_error: {
    type: ERROR,
    zn: '提现数量错误',
    en: 'amount error'
  },
  over_buyback_amount: {
    type: ERROR,
    en: "单次最小回购数量为 200万 BP，每个自然月最多可申请 2 次回购",
    zn: "The minimum buy-back volume per time is 2 million BP"
  },
  buyback_amount_error: {
    type: ERROR,
    zn: '回购数量错误',
    en: 'amount error'
  },
  password_error: {
    type: ERROR,
    zn: '密码错误',
    en: 'password error'
  },
  limit_email_code: {
    type: ERROR,
    zn: '缺少手机验证码',
    en: 'limit code'
  },
  limit_exchange_param: {
    type: ERROR,
    en: "请选择兑换面额或者兑换张数"
  }
};

import { Message } from 'element-ui'


let messageTips = (type, locals) => {
  let tips = CONFIG[type] || CONFIG.RELOAD_THE_PAGE
  tips.message = tips[locals] || tips.en;

  Message(tips);
};

export {
  messageTips
};


